export type SiteConfig = typeof siteConfig;

export const siteConfig = {
    name: "Meteora DLMM Profit Analysis v3.4.1",
    description: "Find out how much you're printing",
};
